import {
  ILoyaltyServiceBestPromotionInput,
  ILoyaltyServiceOfferCartEntryInput,
  LoyaltyServiceServiceMode,
} from 'generated/graphql-gateway';
import { ICartEntryAdapter } from 'state/loyalty/hooks/types';

// The legacy adapter is sanityId-based; the loyalty-service input is
// productId-based with rootReferenceId for nested lines. Children are flattened
// and carry the parent lineId as rootReferenceId.
export const mapAdapterEntriesToServiceEntries = (
  entries: ICartEntryAdapter[],
  rootReferenceId?: string
): ILoyaltyServiceOfferCartEntryInput[] =>
  entries.flatMap(entry => [
    {
      productId: entry.sanityId,
      lineId: entry.lineId,
      price: entry.price,
      quantity: entry.quantity,
      ...(rootReferenceId ? { rootReferenceId } : {}),
    },
    ...mapAdapterEntriesToServiceEntries(entry.children ?? [], entry.lineId),
  ]);

export interface BuildBestPromotionInputArgs {
  cartEntries?: ILoyaltyServiceOfferCartEntryInput[];
  collectionId?: string;
  serviceMode?: LoyaltyServiceServiceMode;
  storeId?: string | null;
  skipStoreDayPartHours?: boolean;
}

export const buildBestPromotionInput = ({
  cartEntries,
  collectionId,
  serviceMode,
  storeId,
  skipStoreDayPartHours,
}: BuildBestPromotionInputArgs): ILoyaltyServiceBestPromotionInput => ({
  includePersonalized: true,
  skipStoreDayPartHours,
  serviceMode,
  // cartEntries and storeId are independently optional; the caller gates storeId
  // on cartEntries presence, so we just include each when it has a value.
  ...(cartEntries?.length ? { cartEntries } : {}),
  ...(collectionId ? { collectionId } : {}),
  ...(storeId ? { storeId } : {}),
});
